import { Grid } from '@material-ui/core';
import { Dispatch, VFC } from 'react';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { SiteProcessSelectfield } from '../../input/ProcessSelectfield';
import { validationMessage } from '../../../../const/ProcessConst';
import { TCopySiteProcessForm } from '../../../../types/process';
import { BaseModal } from '../../../molecules/BaseModal';
import { useStyles } from './useStyles';
import { useHooks } from './useHooks';
import { SiteProcessRadioGroup } from '../../input/ProcessRadioGroup';
import { SiteProcessDatePicker } from '../../input/ProcessDatePicker';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  afterSubmit: () => void;
  constructList: any;
  currentConstructId: number;
  setHasSiteProcess?: Dispatch<boolean>;
  setHasExpectedDays?: Dispatch<boolean>;
};

export const SiteProcessCopyModal: VFC<Props> = props => {
  const {
    isOpen,
    setIsOpen,
    afterSubmit,
    constructList,
    currentConstructId,
    setHasExpectedDays,
    setHasSiteProcess
  } = props;
  const classes = useStyles();

  const methods: UseFormReturn<TCopySiteProcessForm> = useForm();
  const {
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors }
  } = methods;

  const { cancelSubmit, submit, copyCategory, handleChangeOrderTypeRadio } =
    useHooks({
      setIsOpen,
      reset,
      isOpen,
      afterSubmit,
      getValues,
      setValue,
      currentConstructId,
      setHasExpectedDays,
      setHasSiteProcess
    });

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(submit, (erros: any) => {})}
      handleCancelSubmit={cancelSubmit}
      title={'既存の工程表をコピー'}
      buttonCaption={'取り込む'}
      cancelButtonCaption={'キャンセル'}
    >
      <FormProvider {...methods}>
        {/* 期間 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>期間*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <div className={classes.leftAlignContainer}>
            <Grid container>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='start_date'
                    label='開始日'
                    required={true}
                    fullWidth={true}
                    toDate={undefined}
                    errorMessage={errors?.start_date?.message}
                    className={classes.gridItem}
                    errorMessageStyle={{ display: 'none' }}
                  />
                </div>
                <div className={classes.itemMargin}>
                  <label>(契約予定日)</label>
                </div>
              </Grid>
              <p>*</p>
              <Grid item xs={12} md={1}>
                <div className={classes.itemMargin} style={{ width: 20 }}>
                  <span className={classes.textStyle}>〜</span>
                </div>
              </Grid>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='end_date'
                    label='終了日'
                    fullWidth={true}
                    className={classes.gridItem}
                  />
                </div>
                <div className={classes.itemMargin}>
                  <label>(竣工予定日)</label>
                </div>
              </Grid>
              {errors.start_date && (
                <Grid item xs={12}>
                  <div className={`${classes.helperText} ${classes.gridItem}`}>
                    {errors.start_date.message}
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        {/* /期間 */}

        <Grid item xs={11} className={classes.modalCaption}>
          コピーしたい工程表がある「工事件名」を選択してください。
        </Grid>
        {/* 案件名 */}
        <Grid container alignItems='center' justify='center'>
          <Grid item xs={10} md={3} className={classes.gridItem}>
            <label className={classes.label}>案件</label>
          </Grid>
          <Grid item xs={10} md={7}>
            <SiteProcessSelectfield
              name='construct_id'
              listDatas={constructList}
              className={`${classes.input} ${classes.gridItem}`}
              required={true}
              error={'construct_id' in errors}
              errorMessage={errors?.construct_id && validationMessage.required}
            />
          </Grid>
        </Grid>
        {/* /案件名 */}
        {/* コピー範囲 */}
        <Grid item xs={10} md={3}>
          <label className={classes.label}>コピー範囲</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <div
            className={`${classes.leftAlignContainer} ${classes.input}  ${classes.radioContainer}`}
          >
            <SiteProcessRadioGroup
              name='category'
              onChange={handleChangeOrderTypeRadio}
              listDatas={copyCategory}
              getValues={getValues}
              notFlexRow={true}
            />
          </div>
        </Grid>
        {/* /コピー範囲 */}
      </FormProvider>
    </BaseModal>
  );
};
